import { pushFbqEvent } from '@/utils/fbqTrack'
import { useFbRuntimeConfig, waitForFbConfig } from '@/composables/fbq/useFbRuntimeConfig'

const SESSION_KEY = 'fbq_view_content_reported'

function getReportedSet(): Set<string> {
  try {
    const saved = sessionStorage.getItem(SESSION_KEY)
    return new Set(saved ? JSON.parse(saved) : [])
  }
  catch {
    return new Set()
  }
}

function markAsReported(contentId: string) {
  const set = getReportedSet()
  set.add(contentId)
  sessionStorage.setItem(SESSION_KEY, JSON.stringify([...set]))
}

export function useFbqViewContent() {
  const { isEventEnabled } = useFbRuntimeConfig()

  async function reportViewContent(
    contentId: string | number,
    contentName: string,
    contentType: 'book' | 'chapter',
    chapterId?: string | number,
  ) {
    const dedupKey = `${contentId}_${contentType}`
    // 同一 session 内，同一 contentId + contentType 只上报一次（book 和 chapter 独立去重）
    if (getReportedSet().has(dedupKey))
      return

    // 先标记，防止并发调用或 waitForFbConfig 超时重试时重复上报
    markAsReported(dedupKey)

    await waitForFbConfig()
    if (!isEventEnabled('VIEW_CONTENT'))
      return

    pushFbqEvent('ViewContent', {
      content_id: String(contentId),
      content_name: contentName,
      content_type: contentType,
      ...(chapterId ? { chapter_id: String(chapterId) } : {}),
    }, 'fb_view_content')
  }

  return { reportViewContent }
}
